import i18next from 'i18next';

import Constants from '@/constants';

export const getDueDateColor = (dueDate: number | string) => {
  const timeDifference = new Date(dueDate).getTime() - new Date().getTime();
  const daysUntilDue = timeDifference / (1000 * 3600 * 24);

  return Math.ceil(daysUntilDue) >= 7
    ? Constants.DUEDATE_COLORS.DARK_GREEN
    : Math.ceil(daysUntilDue) < 7 && Math.ceil(daysUntilDue) >= 0
      ? Constants.DUEDATE_COLORS.TAN
      : Constants.DUEDATE_COLORS.PURPLE;
};

export const getDueDateString = (dueDate: number | string) => {
  const timeDifference = new Date(dueDate).getTime() - new Date().getTime();
  const daysUntilDue = Math.ceil(timeDifference / (1000 * 3600 * 24));
  const weeksUntilDue = Math.floor(daysUntilDue / 7);

  return daysUntilDue === 7
    ? i18next.t('TrainingPlans.accountability.due.oneWeek')
    : daysUntilDue < 0
      ? i18next.t('TrainingPlans.accountability.due.overdue')
      : daysUntilDue === 1
        ? i18next.t('TrainingPlans.accountability.due.oneDay')
        : daysUntilDue === 0
          ? i18next.t('TrainingPlans.accountability.due.today')
          : daysUntilDue < 7
            ? i18next.t('TrainingPlans.accountability.due.xDays', {
                daysLeft: daysUntilDue,
              })
            : daysUntilDue >= 8 && weeksUntilDue === 1
              ? i18next.t('TrainingPlans.accountability.due.oneWeek')
              : i18next.t('TrainingPlans.accountability.due.xWeeks', {
                  weeksLeft: weeksUntilDue,
                });
};
